import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from '../../http.service';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ImageUploaderComponent } from '../../image-uploader/image-uploader.component';

@Component({
  selector: 'app-front-category-form',
  templateUrl: './front-category-form.component.html',
  styleUrls: ['./front-category-form.component.scss']
})
export class FrontCategoryFormComponent implements OnInit {

  @ViewChild('f', { static: false }) f : NgForm
  @ViewChild("imageUploader") imageUploader : ImageUploaderComponent
  @ViewChild("iconUploader") iconUploader : ImageUploaderComponent
  @ViewChild("featureUploader") featureUploader : ImageUploaderComponent

  public data : any = {status: 1, is_hot_game: 0}
  constructor(private http: HttpService, private activatedRoute: ActivatedRoute) { 
    this.activatedRoute.params.subscribe(params => {
      this.loadData(params['category_uuid']);
    });
  }

  ngOnInit(): void {
  }

  async loadFile(fileInput: any, name: string) {
    this.data[name] = await this.http.fileChangeEvent(fileInput);
  }

  async submit() {

    const s = await this.http.post("/admin/app/category/update", this.data);

    if (s['status']) {
      this.http.naviBack();
    }
    
  }

  async loadData(category_uuid) {

    if(!category_uuid) {
      return;
    }

    this.data = await this.http.post("/admin/app/category", {category_uuid});

    if(this.data.image) {
      this.imageUploader.files = [this.data.image]
    }

    if(this.data.icon) {
      this.iconUploader.files = [this.data.icon]
    }

    if(this.data.feature_image) {
      this.featureUploader.files = [this.data.feature_image]
    }

  }


  upload(data:any, key:string, single = false) {
    this.data[key] = (single) ? data[0] : data
  }

  delete(data:any, key:string) {
    console.log(data, key)
    this.data[key] = data
  }
}
